
export type UpdateNotificationSettingsParams = {
userId: string;
};
